import { DEFAULT_PLACEHOLDER } from '@constants/generic';
import { externalUrlRegex } from '@constants/regex';

import { LeadCustomField } from '../../types/common';

interface FormResponseFieldRowProps {
  field: LeadCustomField;
  isLast?: boolean;
}

const renderValue = (value: string) =>
  externalUrlRegex.test(value) ? (
    <a
      href={value}
      target="_blank"
      rel="noreferrer"
      className="break-all text-base font-medium text-cofeePrimary6 underline"
    >
      {value}
    </a>
  ) : (
    <span className="break-words text-base font-medium text-cofeeNeutral10">
      {value}
    </span>
  );

const renderValues = (values: string[]) => {
  if (!values.length)
    return (
      <span className="text-base font-medium text-cofeeNeutral10">
        {DEFAULT_PLACEHOLDER}
      </span>
    );

  if (values.length === 1) return renderValue(values[0]);

  return (
    <ul className="flex flex-col gap-1">
      {values.map((item) => (
        <li key={item}>{renderValue(item)}</li>
      ))}
    </ul>
  );
};

const FormResponseFieldRow = ({
  field,
  isLast = false
}: FormResponseFieldRowProps) => (
  <>
    <div className="space-y-1 py-3">
      <dt className="break-words text-base font-normal text-cofeeNeutral7">
        {field.key}
      </dt>
      <dd>{renderValues(field.value?.filter(Boolean) ?? [])}</dd>
    </div>
    {!isLast && <hr className="border-cofeeNeutral4" />}
  </>
);

export default FormResponseFieldRow;
